import { Route, Routes } from 'react-router-dom';

import AuthRedirect from '@/app/core/security/AuthRedirect';
import { PrintingLayout } from '@/app/layouts/printing';

import { SuccessTaxReturnPayment } from './components/PaymentDeclarationRegistered';
import { UploadDetails } from './components/UploadDetails';
import { PaymentMatchPage } from './pages/PaymentMatchPage';
import { RecordPaymentPage } from './pages/RecordPayment/RecordPaymentPage';
import { RejectPaymentPage } from './pages/RejectPaymentPage';
import { PaymentSelectTaxReturnPage } from './pages/SelectTaxReturn/PaymentSelectTaxReturnPage';
import { UploadBankInformationPage } from './pages/UploadBankInformationPage';
import { UploadBankInformationSuccessPage } from './pages/UploadBankInformationSuccessPage';
import { ViewBankInformationPage } from './pages/ViewBankInformationPage';
import { ViewPaymentPage } from './pages/ViewPayment/ViewPaymentPage';
import { ViewPaymentsPage } from './pages/ViewPayments/ViewPaymentsPage';

export const PaymentRouting = () => {
  return (
    <>
      <Routes>
        <Route path="" element={<></>} />
        <Route path="new" element={<UploadBankInformationPage />} />
        <Route path=":id/success" element={<SuccessTaxReturnPayment />} />

        <Route path="" element={<RecordPaymentPage />} />
        <Route path="query" element={<RecordPaymentPage />} />
        <Route path="reject" element={<RejectPaymentPage />} />
        <Route path=":id/success" element={<SuccessTaxReturnPayment />} />
        <Route path="declaration/tax-return" element={<PaymentSelectTaxReturnPage />} />
        <Route path="declaration/view" element={<ViewPaymentsPage />} />
        <Route path="declaration/record" element={<RecordPaymentPage />} />
        <Route path="declaration/view/:id" element={<ViewPaymentPage />} />
        <Route path="bank/upload" element={<UploadBankInformationPage />} />
        <Route path="bank/upload/:id/success" element={<UploadBankInformationSuccessPage />} />
        <Route path="bank/view/*" element={<ViewBankInformationPage />} />
        <Route path="check-load-records/:id" element={<ViewBankInformationPage />} />
        <Route path="match" element={<PaymentMatchPage />} />
        <Route
          path="/reports/payments/check-load-records/:id"
          element={
            <AuthRedirect>
              <PrintingLayout>
                <UploadDetails hideCancel={true} />
              </PrintingLayout>
            </AuthRedirect>
          }
        />
      </Routes>
    </>
  );
};
